<template>
  <div
    ref="root"
    class="rd rd--settings ss"
    :data-w="layout"
    :data-density="density"
    :data-bar="barSticky ? 'sticky' : 'flow'"
    :style="rootStyle"
  >
    <div class="rd-main">
      <report-nav :groups="navGroups" :current="currentKey" :label="$t('settings')" @select="ctl.openScreen">
        <template #tools>
          <button
            type="button"
            class="ui-icon-btn ui-icon-btn--sm ui-icon-btn--plain"
            :title="`${$t('report_desktop.shortcuts')} (?)`"
            :aria-label="$t('report_desktop.shortcuts')"
            :aria-expanded="String(helpOpen)"
            @click="helpOpen = !helpOpen"
          >
            <v-icon size="18">mdi-keyboard-outline</v-icon>
          </button>
          <button type="button" class="ui-text-btn rd-nav__legacy" :title="$t('report_desktop.old_view')" @click="ctl.openLegacy()">
            <v-icon size="16" color="#c2410c">mdi-history</v-icon>
            <span class="rd-nav__legacy-label">{{ $t("report_desktop.old_view") }}</span>
          </button>
        </template>
      </report-nav>

      <settings-bar ref="bar" />
      <set-banner />

      <div class="rd-page">
        <div class="rd-head">
          <div class="rd-head__title">
            <h1>{{ ctl.screenTitle(currentKey) }}</h1>
            <p class="rd-head__sub">{{ ctl.screenSub(currentKey) }}</p>
          </div>
          <div class="rd-head__right"><report-kpis :kpis="kpiCards" /></div>
        </div>
        <settings-screen :screen="currentKey" />
      </div>
    </div>

    <report-help-popover :open="helpOpen" :shortcuts="shortcuts" @close="helpOpen = false" />
    <set-toast />
    <set-dialog />
  </div>
</template>

<script>
import "@/components/report/desktop/reportDesktop.scss";
import "./settingsShell.scss";
import ReportNav from "@/components/report/shared/ReportNav.vue";
import ReportKpis from "@/components/report/shared/ReportKpis.vue";
import ReportHelpPopover from "@/components/report/shared/ReportHelpPopover.vue";
import hasReportShell from "@/components/report/shared/hasReportShell";
import SettingsBar from "./SettingsBar.vue";
import SettingsScreen from "./SettingsScreen.vue";
import SetBanner from "./parts/SetBanner.vue";
import SetToast from "./parts/SetToast.vue";
import SetDialog from "./parts/SetDialog.vue";

const baseKeydown = hasReportShell.methods.onKeydown;

/**
 * Podešavanja restorana na računaru: gornja navigacija po grupama (kao u izvještajima i magacinu), lijepljiva traka
 * sa pretragom i snimanjem, zaglavlje sa brojkama i ekran. Stanje je u stranici (`settingsCtl`), ovdje je samo prikaz.
 * Raspored po širini, prečice i obavještenja dolaze iz hasReportShell.
 */
export default {
  name: "SettingsDesktop",
  mixins: [hasReportShell],
  components: { ReportNav, ReportKpis, ReportHelpPopover, SettingsBar, SettingsScreen, SetBanner, SetToast, SetDialog },
  inject: { ctl: "settingsCtl" },
  computed: {
    currentKey() {
      return this.ctl.currentKey || "deadlines";
    },
    menuKeys() {
      return this.ctl.screenKeys;
    },
    navGroups() {
      return this.ctl.groups.map((group) => ({
        ...group,
        items: group.items.map((item) => ({
          ...item,
          badge: item.badge || (item.badgeOff ? this.$t("settings_shell.v.off") : ""),
          badgeComplete: false,
        })),
      }));
    },
    // `kpis` je podatak iz hasReportShell (brojke izvještaja), pa se ovdje zove drukčije
    kpiCards() {
      return this.ctl.kpis.map((kpi, index) => ({ key: index, label: kpi.label, value: kpi.value, tone: kpi.tone || "" }));
    },
    /** Prečice ove stranice (hasReportShell ima prečice izvještaja). */
    shortcuts() {
      return [
        { keys: "Ctrl S", label: this.$t("settings_shell.save") },
        { keys: "/", label: this.$t("settings_shell.search") },
        { keys: "1–7", label: this.$t("report_desktop.keys_report") },
        { keys: "Esc", label: this.$t("report_desktop.keys_close") },
        { keys: "?", label: this.$t("report_desktop.shortcuts") },
      ];
    },
  },
  mounted() {
    document.addEventListener("mousedown", this.onOutside);
  },
  beforeDestroy() {
    document.removeEventListener("mousedown", this.onOutside);
  },
  methods: {
    // hasReportShell poziva ove tri kad korisnik pritisne r ili [ ]: ovdje nemaju značenje
    reload() {},
    shiftDay() {},
    openScreen(key) {
      this.ctl.openScreen(key);
    },
    onKeydown(event) {
      if (event.key === "Escape" && !this.helpOpen && this.ctl.ui.pop) {
        this.ctl.ui.pop = null;
        return;
      }
      if (document.querySelector(".ss-modal")) {
        return;
      }
      baseKeydown.call(this, event);
    },
    onOutside(event) {
      if (this.ctl.ui.pop && !event.target.closest(".ss-pop, [data-open]")) {
        this.ctl.ui.pop = null;
      }
    },
  },
};
</script>
